/*eslint-disable */

import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      title: "Print in Progress",
      content: "Please wait while the PDF is being generated and processed...",
      errMsg: "Failed to generate or print the PDF",
    };
  },
  methods: {
    ...mapActions({
      report: "reports/getReport",
      generateReport: "reports/generateReport",
      generateDynamicReport: "reports/generateDynamicReport",

    }),

    async getReport(query) {
      Swal.fire({
        title: this.title,
        text: this.content,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {

        if(query?.additionalQueryData?.print === 'generate'){
          const result = await this.generateReport(query);
          this.onLoadPrintWindow(result)
        }else if(query?.dynamic){
          const result = await this.generateDynamicReport(query);
          this.onLoadPrintWindow(result)
        }else{
          const result = await this.report(query);
          this.onLoadPrintWindow(result)
        }


      } catch (error) {
        console.error(this.errMsg, error);
        Swal.fire("Error", this.errMsg, "error");
      }
    },

    async onLoadPrintWindow(result){

      let blob = await result.data;

      const blobUrl = URL.createObjectURL(blob);
      const printWindow = window.open(blobUrl);

      return printWindow.onload = function () {
        Swal.close();
        printWindow.print();
        URL.revokeObjectURL(blobUrl);
      };
    }
  },
};
